import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase configuration
// Get this from Firebase Console > Project Settings > Your apps > Web app
// Project ID: stockco-9314d
const firebaseConfig = {
    apiKey: "AIzaSyBa_sj4wPBdpoaKhE-iUyKuXXa-gPwTO6k",
    authDomain: "stockco-9314d.firebaseapp.com",
    projectId: "stockco-9314d",
    storageBucket: "stockco-9314d.firebasestorage.app",
    messagingSenderId: "807312842609",
    appId: "1:807312842609:web:fa760c34b31278871420d0",
    measurementId: "G-448V68YWBL"
  };  

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, auth, db, storage };
